export enum SiteViewMode {
  Add = 'add',
  Edit = 'edit',
  EditCodeOfConduct = 'editCodeOfConduct',
  View = 'view',
  ViewCodeOfConduct = 'viewCodeOfConduct',
}

export enum SiteTabViewMode {
  About = 'about',
  Areas = 'areas',
  Users = 'users',
}

export enum SiteListView {
  Grid = 'grid',
  Map = 'map',
  Table = 'table',
}
